<template>
  <div class="relative">
    <div class="vx-navbar-wrapper navbar-full p-0">
      <vs-navbar
        class="navbar-custom navbar-skelton p-3"
        :class="navbarClasses"
        :style="navbarStyle"
        :color="navbarColor"
      >
        <router-link tag="div" exact to="/" class="vx-logo cursor-pointer">
          <ILogo style="width: auto; height: 24px;" />
          <span class="vx-logo__badge">PRO</span>
        </router-link>

        <!-- <notification-drop-down />-->

        <profile-drop-down />
      </vs-navbar>
    </div>
  </div>
</template>

<script>
import ILogo from '@/assets/svg/kolesa-new-logo.svg';
// import NotificationDropDown from './components/NotificationDropDown.vue';
import ProfileDropDown      from './components/ProfileDropDown.vue';

export default {
  name:       'HeaderHorizontal',
  components: {
    // NotificationDropDown,
    ProfileDropDown,
    ILogo,
  },
  props: {
    logo:       { type: String },
    navbarType: {
      type:     String,
      required: true,
    },
  },
  computed: {
    navbarColor() {
      let color = '#fff';
      if (this.navbarType === 'sticky') color = '#f7f7f7';
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = '#f7f7f7';
        }
      }

      // eslint-disable-next-line no-nested-ternary,no-unused-expressions
      this.isThemedark === 'dark' ? color === '#fff' ? color = '#10163a' : color = '#262c49' : null;

      return color;
    },
    isThemedark() { return this.$store.state.theme; },
    navbarStyle() { return this.navbarType === 'static' ? { transition: 'all .25s ease-in-out' } : {}; },
    navbarClasses() {
      return this.scrollY > 5 && this.navbarType === 'static' ? null : 'd-theme-dark-light-bg shadow';
    },
    scrollY() { return this.$store.state.scrollY; },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth; },
    windowWidth() { return this.$store.state.windowWidth; },
  },
};

</script>
